import Vue from 'vue'
import VueCompositionApi from '@vue/composition-api'
import VueSimpleAlert from 'vue-simple-alert'
import main from './main.vue'
import router from './router/main'
import './main.sass'

Vue.use(VueCompositionApi)
Vue.use(VueSimpleAlert)

Vue.config.productionTip = false

let loaderinstance: any = null

const $LOADER = {
  show (text = '') {
    loaderinstance = Vue.fire({
      text,
      type: 'info',
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false
    })
  },

  hide () {
    if (loaderinstance) {
      loaderinstance.closePopup()
    }
  }
}

const $STORE = new Vue({
  data: {
    username: ''
  }
})

declare global {
  interface Window {
    $STORE: typeof $STORE
    $LOADER: typeof $LOADER
  }
}

window.$STORE = $STORE
window.$LOADER = $LOADER

Object.defineProperty(Vue.prototype, '$STORE', {
  get () {
    return $STORE
  }
})

new Vue({
  router,
  render: h => h(main)
}).$mount('#app')
